import { createFileRoute } from '@tanstack/react-router'
import { SignUpScreen } from '@/components/auth/sign-up-screen'

/**
 * `?next=` and `?email=` — both attached by the invitation screen.
 *
 * An invited person with no account has to create one before they can accept,
 * and without these two the trip back is manual: retype the address the
 * invitation was sent to (getting it wrong means it never matches), then find
 * the email again to re-open the link. `next` carries them back to the
 * invitation, `email` prefills the address it was sent to.
 *
 * Validated here rather than read ad hoc, so the screen receives typed values —
 * and `next` is checked again as a same-origin path before it is navigated to.
 */
export const Route = createFileRoute('/sign-up')({
  validateSearch: (
    search: Record<string, unknown>,
  ): { next?: string; email?: string } => ({
    ...(typeof search.next === 'string' ? { next: search.next } : {}),
    ...(typeof search.email === 'string' ? { email: search.email } : {}),
  }),
  head: () => ({ meta: [{ title: 'Sign up — Constellation QR' }] }),
  component: SignUpScreen,
})
